import React, { useState } from 'react';
import http from '../../http';
import withAuth from '../../HOC/withAuth';
import { useNavigate } from 'react-router';
import PackageForm from './form';
import { observer, inject } from 'mobx-react';
import C from '../../colors';

function BackIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <path d="M19 12H5M11 18l-6-6 6-6"/>
    </svg>
  );
}

const CreatePackageForm = inject('snackbarStore')(observer(({snackbarStore}) => {
  const [name, setName] = useState('');
  const [photoCount, setPhotoCount] = useState('');
  const [price, setPrice] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();

    const packageData = {
      name,
      photoCount,
      price,
    };

    http.post('/user/packages/create', packageData)
      .then(() => {
        snackbarStore.showSnackbar('Package created successfully')
        navigate('/user/packages')
      })
      .catch(error => { });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
      <div style={{ padding: '20px 36px 18px', background: C.paper, borderBottom: `1px solid ${C.hair}`, flexShrink: 0, position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', background: `radial-gradient(700px 180px at 100% -50%, ${C.brand}24, transparent 70%)` }}/>
        <div style={{ position: 'relative' }}>
          <button onClick={() => navigate('/user/packages')} style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            marginBottom: 10, padding: '5px 10px 5px 6px',
            background: 'none', border: `1px solid ${C.hair}`,
            borderRadius: 7, cursor: 'pointer',
            fontFamily: C.sans, fontSize: 12, color: C.ink3,
          }}>
            <BackIcon/> 套餐列表
          </button>
          <h2 style={{ margin: 0, fontFamily: C.serif, fontSize: 32, lineHeight: 1.05, fontWeight: 400, color: C.ink }}>
            创建套餐
          </h2>
        </div>
      </div>

      <div style={{ flex: 1, overflow: 'auto' }}>
        <div style={{ padding: '24px 44px 64px' }}>
          <div style={{ fontFamily: C.mono, fontSize: 10, letterSpacing: 1.5, textTransform: 'uppercase', color: C.brand, fontWeight: 600, marginBottom: 16, marginTop: 8 }}>
            套餐信息
          </div>
          <PackageForm
            formId="package-form"
            handleSubmit={handleSubmit}
            name={name}
            setName={setName}
            photoCount={photoCount}
            setPhotoCount={setPhotoCount}
            price={price}
            setPrice={setPrice}
          />
        </div>
      </div>

      <footer style={{
        borderTop: `1px solid ${C.hair}`,
        padding: '14px 36px',
        display: 'flex', justifyContent: 'flex-end', alignItems: 'center',
        background: C.paper, flexShrink: 0,
      }}>
        <button form="package-form" type="submit" style={{
          fontFamily: C.sans, fontSize: 14, fontWeight: 500,
          padding: '10px 24px', borderRadius: 7,
          background: C.brand, color: '#fff', border: 'none',
          cursor: 'pointer',
          boxShadow: `0 1px 0 ${C.brand2}, 0 6px 16px -8px rgba(217,79,146,.55)`,
        }}>
          创建套餐
        </button>
      </footer>
    </div>
  );
}));

export default withAuth(CreatePackageForm);
